import { render, staticRenderFns } from "./NewsDetailItem3.vue?vue&type=template&id=7bccddde"
import script from "./NewsDetailItem3.vue?vue&type=script&lang=ts"
export * from "./NewsDetailItem3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports